import { getNumberValueSeparatedByCommas } from '@/Utils/utils';
import { generatePathForNode } from '@/helpers/spreadsheetHelper';
import '@/pages/SpreadsheetPage/index.scss';
import CustomGroupMenu from './CustomGroupMenu';

const CustomAutoGroupValue = ({ data: { groupCount }, value, node }) => {
  if (!value) return null;

  const path = generatePathForNode(node);
  const { field } = node;

  return (
    <div className='autoGroupColumn'>
      <span className='autoGroupColumn-group-value text-ui'>{value}</span>
      <span className='autoGroupColumn-group-count'>
        ({getNumberValueSeparatedByCommas(groupCount)})
      </span>
      <CustomGroupMenu node={node} field={field} path={path} />
    </div>
  );
};

export default CustomAutoGroupValue;
